var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8711A9F3-9038-4598-85A0-466046D7F3EF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "20.0_Analytics_1.9",
    transform: "translate(-377.000000, -180.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content-Copy",
    transform: "translate(337.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-(1)",
    transform: "translate(40.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.0004354 C0,8.05840952 8.05896509,0 17.9997823,0 C27.9410349,0 36,8.05840952 36,18.0004354 C36,27.9410826 27.9410349,36 17.9997823,36 C8.05896509,36 0,27.9410826 0,18.0004354 Z",
    id: "Path",
    fill: "#25B7D3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.795095, 6.794859)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8261673,4.18366348 L18.2262253,0.583750545 C17.4479007,-0.194656072 16.1859801,-0.194510955 15.4078005,0.583750545 L9.8476443,6.14390147 C9.06939221,6.92230808 9.06931965,8.18417138 9.84757174,8.962578 L13.4475137,12.5624909 C14.2258383,13.340825 15.4877589,13.3407524 16.266011,12.5623458 L21.8261673,7.00219489 C22.6043468,6.22400595 22.6044194,4.96199753 21.8261673,4.18366348 Z M15.8856644,10.2868415 C15.4293501,10.7430888 14.6896261,10.7431614 14.2333843,10.2869141 L12.1231211,8.17662531 C11.6668793,7.72037803 11.6669519,6.98064505 12.1231936,6.52432521 L15.7881471,2.85932738 C16.2443163,2.40315266 16.9840404,2.40308011 17.4403547,2.85932738 L19.5506179,4.96968873 C20.0068597,5.42586345 20.0067872,6.16559643 19.5506179,6.62184371 L15.8856644,10.2868415 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5622392,13.4477035 L8.96236985,9.8477906 C8.1840452,9.06945654 6.92212461,9.0695291 6.14387252,9.8477906 L0.583716276,15.4080866 C-0.194535813,16.1863481 -0.19460837,17.448284 0.583716276,18.2265455 L4.18365823,21.826531 C4.96191032,22.604865 6.22390347,22.6047199 7.00208301,21.826531 L12.5623118,16.2661624 C13.3404188,15.4879734 13.3405639,14.2260376 12.5622392,13.4477035 Z M6.62166387,19.5508816 C6.1654221,20.0071289 5.42577062,20.007274 4.9694563,19.5509541 L2.85919304,17.4406654 C2.40287872,16.9844181 2.40295128,16.2446851 2.85919304,15.7884378 L6.5242191,12.1233674 C6.9803883,11.6671927 7.72011234,11.6671202 8.17642666,12.1233674 L10.2866899,14.2336562 C10.7429317,14.6899761 10.7428591,15.429709 10.2866899,15.8858838 L6.62166387,19.5508816 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.2684145,13.9072704 L22.0928253,13.7316064 C21.5310849,13.1697867 20.6170051,13.1697867 20.0551921,13.7316064 L13.7317306,20.0551444 C13.1699902,20.6168916 13.1699902,21.5309824 13.7317306,22.0927296 L13.9073198,22.2683936 C14.4690603,22.8300682 15.38314,22.8300682 15.944953,22.2683936 L22.2684145,15.9447831 C22.8301549,15.3831084 22.8301549,14.468945 22.2684145,13.9072704 Z",
    id: "Path",
    fill: "#48A1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6287473,21.952184 C15.2407096,22.3402264 14.6114907,22.3402989 14.223453,21.9522566 L14.0477912,21.7765927 C13.6597535,21.3885503 13.6597535,20.7593238 14.0477912,20.3713539 L20.3713253,14.0477434 C20.7593629,13.6596285 21.3885093,13.6597011 21.7766195,14.0478886 L21.9522088,14.2234799 C22.3401739,14.6115223 22.340319,15.2406762 21.9522088,15.6286461 L15.6287473,21.952184 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.c0a1c2bc71b530c0192610ffe1c547e0.svg";
export { ForwardRef as ReactComponent };